import React from "react";

import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import "./styles.scss";

const TabItem = ({ text, icon, selected, link, onClick, noMargin }) => {
  const history = useHistory();
  return (
    <div
      onClick={() => {
        link && history.push(link);
        onClick && onClick(text);
      }}
      className={`tabitem ${selected && "tabitem-selected"} ${
        noMargin && "no-margin"
      }`}>
      {icon && <div className={"icon"}>{icon}</div>}
      <p>{text}</p>
    </div>
  );
};

TabItem.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.node,
  selected: PropTypes.bool,
  step: PropTypes.shape({
    changeTab: PropTypes.func.isRequired,
  }).isRequired,
  action: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
  noMargin: PropTypes.bool,
};

export default TabItem;
